import { render, staticRenderFns } from "./LayoutElementTypeImage.vue?vue&type=template&id=17e2bd49&scoped=true"
import script from "./LayoutElementTypeImage.vue?vue&type=script&lang=js"
export * from "./LayoutElementTypeImage.vue?vue&type=script&lang=js"
import style0 from "./LayoutElementTypeImage.vue?vue&type=style&index=0&id=17e2bd49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2bd49",
  null
  
)

export default component.exports